<template>
  <div class="message-box-bg flex-center" v-if="showMessageBox">
    <div class="message-box">
      <div class="message-box-main">
        <div class="message-box-top">
          <!-- <h4>Acknowledgement of Terms</h4> -->
          <i class="icon icon-close" @click="onShowMessageBox"></i>
        </div>
        <div class="message-box-content">
          <i class="icon icon-pair-suspended"></i>
          <h4>
            {{
              $t("home.walletConnect.acknowledgementTermsMessageBox.readThis")
            }}
          </h4>
          <p>
            {{
              $t(
                "home.walletConnect.acknowledgementTermsMessageBox.byTradingText"
              )
            }}
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://marginx.io/terms/"
              ><strong class="text-invite-address">
                &lt;{{
                  $t(
                    "home.walletConnect.acknowledgementTermsMessageBox.termsofUseText"
                  )
                }}&gt;</strong
              ></a
            >

            {{
              $t("home.walletConnect.acknowledgementTermsMessageBox.andText")
            }}
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://marginx.io/privacy-policy/"
              ><strong class="text-invite-address">
                &lt;{{
                  $t(
                    "home.walletConnect.acknowledgementTermsMessageBox.privacyPolicyText"
                  )
                }}&gt;</strong
              >.</a
            >
          </p>
          <p>
            {{
              $t(
                "home.walletConnect.acknowledgementTermsMessageBox.itAppearsText"
              )
            }}
          </p>
        </div>
      </div>
      <div class="message-box-bott">
        <p>
          {{ $t("home.walletConnect.acknowledgementTermsMessageBox.text1") }}
        </p>
        <p>
          {{ $t("home.walletConnect.acknowledgementTermsMessageBox.text2") }}
        </p>
        <p>
          {{ $t("home.walletConnect.acknowledgementTermsMessageBox.text3") }}
        </p>
        <p>
          {{ $t("home.walletConnect.acknowledgementTermsMessageBox.text4") }}
        </p>
        <p>
          {{ $t("home.walletConnect.acknowledgementTermsMessageBox.text5") }}
        </p>
        <label for="radio" class="i-agree flex-center">
          <input
            type="radio"
            id="radio"
            :checked="isChecked"
            @click="getRadioVal"
          />
          <h6 class="background-clip-text h6-min">
            {{ $t("home.walletConnect.acknowledgementTermsMessageBox.iAgree") }}
          </h6>
        </label>
        <ButtonCommon
          type="marginXBridge"
          class="flex-center box-but"
          width="320px"
          :disabled="!isChecked"
          @click="toIAgree"
        >
          <strong class="text-max">{{
            $t("home.walletConnect.acknowledgementTermsMessageBox.next")
          }}</strong>
        </ButtonCommon>
      </div>
    </div>
  </div>
</template>
<script>
import ButtonCommon from "@/components/Common/button";
export default {
  name: "MessageBox",
  data() {
    return {
      isChecked: false,
    };
  },
  components: {
    ButtonCommon,
  },
  props: {
    showMessageBox: Boolean,
  },

  methods: {
    getRadioVal() {
      this.isChecked = !this.isChecked;
    },
    onShowMessageBox() {
      this.$emit("update:showMessageBox", !this.showMessageBox);
    },

    toIAgree() {
      this.$emit("iAgree");
    },
  },
};
</script>
<style lang="scss" scoped>
.message-box-bg {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9999;
  background: colorRgba(#000, 0.68);
  flex-direction: column;
  .message-box-main {
    position: relative;
    padding: 24px 32px 32px;
    background: #2a2c32;
    border-radius: 20px;
  }
  .message-box-bott {
    padding: 30px 32px 32px;
    box-sizing: border-box;
    border-radius: 20px;
    .i-agree {
      cursor: pointer;
      margin-top: 16px;
      margin-bottom: 32px;
      input {
        margin-top: 0px;
        margin-right: 12px;
        /* 隐藏原有样式 */
        appearance: none;
        -webkit-appearance: none;
        outline: none;
        /* 增加新样式:未选中时 */
        width: 16px;
        height: 16px;
        display: block;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
        background-image: url("~@/assets/images/icon/I-agree-not.svg");
        &:checked {
          background-image: url("~@/assets/images/icon/I-agree.svg");
        }
      }
    }

    p {
      position: relative;
      padding-bottom: 16px;
      opacity: 0.8;
      padding-left: 16px;
      font-size: 12px;

      &::before {
        content: "";
        position: absolute;
        left: 0;
        top: 3px;
        height: 5px;
        width: 5px;
        border-radius: 50%;
        opacity: 0.5;
        background: #ffffff;
      }
    }
  }
  .message-box {
    width: 480px;
    background: #1e1f23;
    border-radius: 24px;
    z-index: 9999;
    .message-box-top {
      position: absolute;
      right: 32px;
      margin-bottom: 24px;
      .icon-close {
        cursor: pointer;
        position: absolute;
        top: 0;
        right: 0;
      }
    }

    .message-box-content {
      .icon-pair-suspended {
        display: block;
        margin-left: auto;
        margin-right: auto;
        margin-bottom: 24px;
      }
      a {
        text-decoration: none;
        color: inherit;
      }
      h4 {
        text-align: center;
        margin-bottom: 24px;
      }
      p {
        max-width: 417px;
        text-align: center;
        line-height: 21px;

        &:last-child {
          margin-top: 20px;
        }
      }
      .text-invite-address {
        color: #a6f616;
      }
    }
  }
}
</style>
